import { toTitleCase } from "../../util/toTitleCase";

const DeleteConfirmationModal = ({
  isOpen,
  isLoading,
  itemName,
  itemType = "Item",
  warningMessage,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={() => !isLoading && onCancel()}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          padding: "24px",
          maxWidth: "480px",
          width: "90%",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "16px",
          }}
        >
          <span
            style={{
              fontSize: "2rem",
              color: "#dc3545",
            }}
          >
            ⚠️
          </span>
          <h2
            style={{
              margin: 0,
              color: "#333",
              fontSize: "1.4rem",
            }}
          >
            Delete {itemType}?
          </h2>
        </div>

        <p
          style={{
            color: "#555",
            lineHeight: "1.6",
            marginBottom: "8px",
          }}
        >
          Are you sure you want to delete{" "}
          <strong>{toTitleCase(itemName)}</strong>? This action cannot be
          undone.
        </p>

        <div
          style={{
            backgroundColor: "#fff3cd",
            border: "1px solid #ffc107",
            borderRadius: "8px",
            padding: "12px",
            marginBottom: "20px",
          }}
        >
          <p
            style={{
              color: "#856404",
              margin: 0,
              fontSize: "0.9rem",
            }}
          >
            {warningMessage}
          </p>
        </div>

        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={onCancel}
            disabled={isLoading}
            style={{
              padding: "10px 20px",
              backgroundColor: "#e9ecef",
              border: "1px solid #dee2e6",
              borderRadius: "6px",
              cursor: isLoading ? "not-allowed" : "pointer",
              fontSize: "1rem",
              opacity: isLoading ? 0.6 : 1,
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            style={{
              padding: "10px 20px",
              backgroundColor: "#dc3545",
              color: "#fff",
              border: "1px solid #dc3545",
              borderRadius: "6px",
              cursor: isLoading ? "not-allowed" : "pointer",
              fontSize: "1rem",
              opacity: isLoading ? 0.6 : 1,
            }}
          >
            {isLoading ? "Deleting..." : `Delete ${itemType}`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
